import { __assign, __extends } from "tslib";
import * as React from 'react';
import { Loader } from 'wix-style-react';
var isSSR = function () { return typeof window === 'undefined'; };
var getSuspenseFetcher = function () {
    var data;
    var promise;
    var ssrCount = 0;
    return function (_a) {
        var fetch = _a.fetch, setRefetchedData = _a.setRefetchedData;
        if (!isSSR()) {
        }
        else if (ssrCount++ > 10) {
            return {};
        }
        if (setRefetchedData) {
            // tslint:disable-next-line: no-floating-promises
            fetch().then(function (res) {
                setRefetchedData(res);
            });
        }
        if (data) {
            return data;
        }
        if (!promise) {
            promise = fetch().then(function (res) {
                data = res;
            });
        }
        throw promise;
    };
};
var FetcherHOC = /** @class */ (function (_super) {
    __extends(FetcherHOC, _super);
    function FetcherHOC(props) {
        var _this = _super.call(this, props) || this;
        _this.reFetch = _this.reFetch.bind(_this);
        var _a = _this.props, fetcher = _a.fetcher, initialFetch = _a.initialFetch;
        if (!isSSR()) {
            _this.state = {
                fetchData: fetcher({ fetch: initialFetch }),
            };
        }
        return _this;
    }
    FetcherHOC.prototype.reFetch = function (fetch) {
        var _this = this;
        var setRefetchedData = function (fetchData) { return _this.setState({ fetchData: fetchData }); };
        this.props.fetcher({ fetch: fetch, setRefetchedData: setRefetchedData });
    };
    FetcherHOC.prototype.render = function () {
        var _a = this.props, fetcher = _a.fetcher, initialFetch = _a.initialFetch, additionalProps = _a.additionalProps;
        return React.createElement(this.props.WrappedComponent, __assign({ fetchData: !isSSR()
                ? this.state.fetchData
                : fetcher({ fetch: initialFetch }), reFetch: this.reFetch }, additionalProps));
    };
    return FetcherHOC;
}(React.Component));
export var withSuspenseFetcherHOC = function (fetchBuilder, WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(SuspenseFetcher, _super);
        function SuspenseFetcher(props) {
            var _this = _super.call(this, props) || this;
            _this.fetcher = getSuspenseFetcher();
            return _this;
        }
        SuspenseFetcher.prototype.render = function () {
            return (React.createElement(React.Suspense, { fallback: React.createElement(Loader, { status: "loading" }) },
                React.createElement(FetcherHOC, { fetcher: this.fetcher, initialFetch: fetchBuilder(this.props), WrappedComponent: WrappedComponent, additionalProps: this.props })));
        };
        return SuspenseFetcher;
    }(React.Component));
};
export var WithSuspenseFetcher = function (fetchBuilder) { return function (component) {
    return withSuspenseFetcherHOC(fetchBuilder, component);
}; };
//# sourceMappingURL=with-suspense-fetcher.js.map